(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.cart-page__form');
        if (!this.form) return;
        this.status = this.querySelector('[data-cart-status]');
        this.form.addEventListener('submit', (event) => {
          this.form.setAttribute('aria-busy', 'true');
          this.status.textContent = this.dataset.updatingLabel;
          window.setTimeout(() => {
            this.form.querySelectorAll('button, input').forEach((control) => { control.disabled = true; });
            if (event.submitter) event.submitter.disabled = true;
          }, 0);
        });
        this.querySelectorAll('[data-cart-quantity]').forEach((button) => {
          button.addEventListener('click', () => {
            const input = button.parentElement.querySelector('input');
            input.value = Math.max(0, Number(input.value || 0) + Number(button.dataset.cartQuantity));
            const update = this.form.querySelector('[name="update"]');
            this.form.requestSubmit(update);
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuDetails = document.querySelectorAll('.site-header details');
  const mobileMenu = document.querySelector('.site-header .mobile-menu');

  if (mobileMenu) {
    const menuLabel = mobileMenu.querySelector('[data-menu-label]');

    mobileMenu.addEventListener('toggle', () => {
      if (!menuLabel) return;
      menuLabel.textContent = mobileMenu.open ? mobileMenu.dataset.closeLabel : mobileMenu.dataset.openLabel;
    });
  }

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;

    const activeDetails = event.target.closest('details[open]') || document.querySelector('.site-header details[open]');

    if (!activeDetails) return;

    activeDetails.removeAttribute('open');
    activeDetails.querySelector(':scope > summary')?.focus();
  });

  document.addEventListener('click', (event) => {
    menuDetails.forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url) return;
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const source = html.querySelector('product-recommendations');
            if (source && source.innerHTML.trim()) this.innerHTML = source.innerHTML;
          })
          .catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-details')) {
    customElements.define('product-details', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
        this.variantInput = this.querySelector('[data-variant-id]');
        this.optionInputs = [...this.querySelectorAll('[data-option-position]')];
        this.optionInputs.forEach((input) => input.addEventListener('change', () => this.updateVariant()));
        this.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => this.showMedia(button.dataset.mediaTarget)));
        this.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.quantityChange))));
        this.variantInput.disabled = false;
      }

      updateVariant() {
        const variant = this.variants.find((item) =>
          this.optionInputs.every((input) => item.options[Number(input.dataset.optionPosition) - 1] === input.value)
        );
        const submit = this.querySelector('[data-product-submit]');
        const submitText = this.querySelector('[data-product-submit-text]');
        const availability = this.querySelector('[data-product-availability]');
        const status = this.querySelector('[data-product-status]');

        if (!variant) {
          this.variantInput.value = '';
          submit.disabled = true;
          submitText.textContent = this.dataset.labelUnavailable;
          availability.textContent = this.dataset.labelUnavailable;
          status.textContent = this.dataset.statusUnavailable;
          return;
        }

        this.variantInput.value = variant.id;
        this.querySelector('[data-product-price]').textContent = variant.price;
        const compare = this.querySelector('[data-product-compare]');
        compare.hidden = !variant.compareAt;
        compare.textContent = variant.compareAt || '';
        submit.disabled = !variant.available;
        submitText.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
        availability.textContent = variant.available ? this.dataset.labelAvailable : this.dataset.labelSoldOut;
        status.textContent = variant.available ? this.dataset.statusAvailable : this.dataset.statusSoldOut;
        if (variant.mediaId) this.showMedia(String(variant.mediaId));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      showMedia(mediaId) {
        this.querySelectorAll('[data-media-id]').forEach((media) => { media.hidden = media.dataset.mediaId !== mediaId; });
        this.querySelectorAll('[data-media-target]').forEach((button) => button.setAttribute('aria-current', String(button.dataset.mediaTarget === mediaId)));
      }

      changeQuantity(change) {
        const input = this.querySelector('input[name="quantity"]');
        input.value = Math.max(1, Number(input.value || 1) + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
